import { Component, Input, Output, EventEmitter, ViewEncapsulation, OnInit } from '@angular/core';
import { Profile } from '../../../core/models/profile';
import { EnvironmentService } from 'src/app/core/enviroment/environment.service';
import { LoginService } from 'lps-navigation';

@Component({
  selector: 'app-broker-profile-card',
  templateUrl: './broker-profile-card.component.html',
  styleUrls: ['./broker-profile-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BrokerProfileCardComponent implements OnInit {

  @Input()
  public isModal = false;

  @Input()
  public dataForm?: Profile;

  @Output()
  public send = new EventEmitter<boolean>();

  readonly messageInvalidCreci: string = 'Não será possível compartilhar o cartão, pois o CRECI está inválido.';
  public profileDefault = 'https://bucketsquadcrm.s3.amazonaws.com/default_images/profile_default.jpg';
  public url = `${window.location.host}`;
  public isMobile: boolean;
  public uriLopes: string;
  public uri: string;

  constructor(
    public environmentService: EnvironmentService
  ) { }

  ngOnInit() {
    this.isMobile = document.body.offsetWidth < 768;
    this.uriLopes = `${this.environmentService.getEnvVar('base_url_portal')}associado/${this.dataForm.nickname}`;
    this.uri = `${this.environmentService.getEnvVar('uri_lopes')}/associado/${this.dataForm.nickname}`;
  }
 
}
